import { Navigate } from "react-router-dom";

// Authentication
import Login from "../pages/Authentication/Login";

// Components
import Builder from "pages/Builder";
import BuilderDetail from "pages/BuilderDetail";
import ListingDetail from "pages/ListingDetail";
import Users from "pages/Users";
import UserDetailPage from "pages/Users/UserDetailPage";
// import Inspector from "pages/Inspector";
// import InspectorDetailPage from "pages/Inspector/InspectorDetailPage";
import Properties from "pages/Properties";
import PropertiesListingDetailPage from "pages/Properties/PropertiesListingDetailPage";
// import Documents from "pages/Documents";
import SettingsUI from "pages/Settings";
// import SupportUI from "pages/Support";
// import Dashboard from "pages/Dashboard";
import ConfigPage from "pages/Config";
import AccessRequests from "pages/AccessRequests";
import AccessHistory from "pages/AccessHistory";
import Reports from "pages/Reports";
import Polls from "pages/Polls";
import Condominiums from "pages/Condominiums";
// import RefundsPage from "pages/RefundPage";
// import Revenue from "pages/Revenue";

const authProtectedRoutes = [
  // Dashboard
  // { path: "/dashboard", component: <Dashboard /> },

  // Builder
  { path: "/builder", component: <Builder /> },
  { path: "/builder-detail", component: <BuilderDetail /> },
  { path: "/listing-detail", component: <ListingDetail /> },

  // Users
  { path: "/users", component: <Users /> },
  { path: "/user-details", component: <UserDetailPage /> },
  { path: "/access-requests", component: <AccessRequests /> },
  {
    path: "/past-guest-access",
    component: <AccessHistory />,
  },
  {
    path: "/reports",
    component: <Reports />,
  },
  {
    path: "/polls",
    component: <Polls />,
  },
  {
    path: "/condominiums",
    component: <Condominiums />,
  },

  // Inspector
  // { path: "/inspector", component: <Inspector /> },
  // { path: "/inspector-details", component: <InspectorDetailPage /> },

  // Properties
  { path: "/properties", component: <Properties /> },
  {
    path: "/properties-listing-detail",
    component: <PropertiesListingDetailPage />,
  },

  // Documents
  // { path: "/documents", component: <Documents /> },

  // Settings
  { path: "/settings", component: <SettingsUI /> },

  // Support
  // { path: "/support", component: <SupportUI /> },

  // Revenue
  // { path: "/revenue", component: <Revenue /> },
  // { path: "/refunds", component: <RefundsPage/> },

  // Configurations
  { path: "/configurations", component: <ConfigPage /> },

  // Default redirects
  {
    path: "/",
    exact: true,
    component: <Navigate to="/dashboard" />,
  },
  { path: "*", component: <Navigate to="/dashboard" /> },
];

const publicRoutes = [{ path: "/login", component: <Login /> }];

export { authProtectedRoutes, publicRoutes };
